<template>
  <head>
    <meta charset="utf-8" />
    <title>Plot Rent | Plot Statement</title>
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <link rel="shortcut icon" href="assets/images/favicon.svg">
    <link href="assets/css/bootstrap.min.css" id="bootstrap-style" rel="stylesheet" type="text/css" />
    <link href="assets/css/icons.min.css" rel="stylesheet" type="text/css" />
    <link href="assets/css/app.min.css" id="app-style" rel="stylesheet" type="text/css" />
    <link href="assets/css/custom.css" id="app-style" rel="stylesheet" type="text/css" />
  </head>

  <body data-sidebar="dark">
  <div id="layout-wrapper">
    <NavigationBar/>

    <div id="content" class="content-minimize">
      <div class="page-content">
        <div class="container-fluid">
          <!-- Page title -->
          <div class="row">
            <div class="col-12">
              <div class="page-title-box d-sm-flex align-items-center justify-content-between">
                <h4 class="mb-sm-0 font-size-18 text-uppercase">Plot Statement</h4>
                <div class="page-title-right">
                  <ol class="breadcrumb m-0">
                    <li class="breadcrumb-item"><a href="javascript: void(0);">Plot Rent</a></li>
                    <li class="breadcrumb-item active">Plot Statement</li>
                  </ol>
                </div>
              </div>
            </div>
          </div>

          <!-- Action Buttons -->
          <div class="row mb-3">
            <div class="col-12">
              <div class="d-flex justify-content-between align-items-center">
                <button class="btn btn-success btn-sm" @click="exportToCSV" :disabled="filteredStatement.length === 0">
                  <i class="mdi mdi-file-excel me-1"></i>Export CSV
                </button>
              </div>
            </div>
          </div>

          <!-- Loading State -->
          <div v-if="loading" class="row">
            <div class="col-12">
              <div class="card">
                <div class="card-body text-center py-5">
                  <div class="spinner-border text-primary" role="status">
                    <span class="visually-hidden">Loading...</span>
                  </div>
                  <p class="mt-3 text-muted">Loading plot statement...</p>
                </div>
              </div>
            </div>
          </div>

          <!-- Error State -->
          <div v-else-if="error" class="row">
            <div class="col-12">
              <div class="alert alert-danger" role="alert">
                <i class="mdi mdi-alert-circle me-2"></i>{{ error }}
              </div>
            </div>
          </div>

          <!-- Statement Content -->
          <div v-else-if="plot">
            <!-- Plot Details Card -->
            <div class="row">
              <div class="col-12">
                <div class="card">
                  <div class="card-header bg-primary">
                    <h5 class="card-title mb-0 text-white">
                      <i class="mdi mdi-home-outline me-2"></i>Plot Details
                    </h5>
                  </div>
                  <div class="card-body">
                    <div class="row">
                      <div class="col-md-3">
                        <div class="mb-3">
                          <label class="text-muted small d-block">Plot Number</label>
                          <strong class="font-size-16 text-primary">{{ plot.plotNumber }}</strong>
                        </div>
                      </div>
                      <div class="col-md-3">
                        <div class="mb-3">
                          <label class="text-muted small d-block">Zone</label>
                          <strong>{{ plot.zone || '-' }}</strong>
                        </div>
                      </div>
                      <div class="col-md-3">
                        <div class="mb-3">
                          <label class="text-muted small d-block">Sub County</label>
                          <strong>{{ plot.subCountyName || '-' }}</strong>
                        </div>
                      </div>
                      <div class="col-md-3">
                        <div class="mb-3">
                          <label class="text-muted small d-block">Ward</label>
                          <strong>{{ plot.wardName || '-' }}</strong>
                        </div>
                      </div>
                      <div class="col-md-4">
                        <div class="mb-3">
                          <label class="text-muted small d-block">Owner Name</label>
                          <strong>{{ plot.ownerNames }}</strong>
                        </div>
                      </div>
                      <div class="col-md-4">
                        <div class="mb-3">
                          <label class="text-muted small d-block">Phone Number</label>
                          <strong>{{ plot.ownerPhoneNo || '-' }}</strong>
                        </div>
                      </div>
                      <div class="col-md-4">
                        <div class="mb-3">
                          <label class="text-muted small d-block">Email</label>
                          <strong>{{ plot.ownerEmail || '-' }}</strong>
                        </div>
                      </div>
                      <div class="col-md-4">
                        <div class="mb-0">
                          <label class="text-muted small d-block">Owner ID</label>
                          <strong>{{ plot.ownerID || '-' }}</strong>
                        </div>
                      </div>
                      <div class="col-md-4">
                        <div class="mb-0">
                          <label class="text-muted small d-block">Plot Size</label>
                          <strong>{{ plot.plotSize || '-' }}</strong>
                        </div>
                      </div>
                      <div class="col-md-4">
                        <div class="mb-0">
                          <label class="text-muted small d-block">Plot Address</label>
                          <strong>{{ plot.plotAddress || '-' }}</strong>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Current Account Status Card -->
            <div class="row">
              <div class="col-12">
                <div class="card">
                  <div class="card-header bg-dark">
                    <h5 class="card-title mb-0 text-white">
                      <i class="mdi mdi-cash-multiple me-2"></i>Current Account Status
                    </h5>
                  </div>
                  <div class="card-body">
                    <div class="row text-center">
                      <div class="col-md-2">
                        <div class="p-3 bg-light rounded">
                          <small class="text-muted d-block">Arrears B/F</small>
                          <h5 class="mb-0 text-danger">KES {{ numberFormat(plot.arrearsForward) }}</h5>
                        </div>
                      </div>
                      <div class="col-md-2">
                        <div class="p-3 bg-light rounded">
                          <small class="text-muted d-block">Total Billed</small>
                          <h5 class="mb-0 text-info">KES {{ numberFormat(plot.totalBilled) }}</h5>
                        </div>
                      </div>
                      <div class="col-md-2">
                        <div class="p-3 bg-light rounded">
                          <small class="text-muted d-block">Accumulated Penalty</small>
                          <h5 class="mb-0 text-warning">KES {{ numberFormat(plot.accumulatedPenalty) }}</h5>
                        </div>
                      </div>
                      <div class="col-md-2">
                        <div class="p-3 bg-light rounded">
                          <small class="text-muted d-block">Total Payments</small>
                          <h5 class="mb-0 text-success">KES {{ numberFormat(plot.totalPayments) }}</h5>
                        </div>
                      </div>
                      <div class="col-md-2">
                        <div class="p-3 bg-light rounded">
                          <small class="text-muted d-block">Annual Rent</small>
                          <h5 class="mb-0 text-primary">KES {{ numberFormat(plot.annualRent) }}</h5>
                        </div>
                      </div>
                      <div class="col-md-2">
                        <div class="p-3 rounded" :class="parseFloat(plot.currentBalance) > 0 ? 'bg-danger' : 'bg-success'">
                          <small class="text-white d-block">Current Balance</small>
                          <h5 class="mb-0 text-white">KES {{ numberFormat(plot.currentBalance) }}</h5>
                        </div>
                      </div>
                    </div>

                    <!-- Status Badge -->
                    <div class="mt-3 text-center">
                      <span class="badge" :class="plot.status === 'Active' ? 'bg-success' : 'bg-secondary'" style="font-size: 14px; padding: 8px 16px;">
                        Status: {{ plot.status || 'Active' }}
                      </span>
                      <span v-if="plot.lastPaymentDate" class="ms-3 text-muted">
                        <i class="mdi mdi-clock-outline me-1"></i>Last Payment: {{ formatDate(plot.lastPaymentDate) }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Filter Card -->
            <div class="row">
              <div class="col-12">
                <div class="card">
                  <div class="card-header bg-secondary">
                    <h5 class="card-title mb-0 text-white">
                      <i class="mdi mdi-filter-outline me-2"></i>Filter Transactions
                    </h5>
                  </div>
                  <div class="card-body">
                    <div class="row align-items-end">
                      <div class="col-md-4">
                        <div class="mb-3 mb-md-0">
                          <label class="form-label">Transaction Type</label>
                          <select class="form-select" v-model="filters.transactionType">
                            <option value="">All Transactions</option>
                            <option value="Payment">Payments Only</option>
                            <option value="Penalty">Penalties Only</option>
                            <option value="Annual Rent">Annual Rent Only</option>
                            <option value="Arrears">Arrears Only</option>
                          </select>
                        </div>
                      </div>
                      <div class="col-md-4">
                        <button class="btn btn-primary" @click="applyFilter">
                          <i class="mdi mdi-magnify me-1"></i>Apply Filter
                        </button>
                        <button class="btn btn-outline-danger ms-2" @click="clearFilters">
                          <i class="mdi mdi-close me-1"></i>Clear
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Transactions Table Card -->
            <div class="row">
              <div class="col-12">
                <div class="card">
                  <div class="card-header bg-info d-flex justify-content-between align-items-center">
                    <h5 class="card-title mb-0 text-white">
                      <i class="mdi mdi-format-list-bulleted me-2"></i>Account Statement
                    </h5>
                    <span class="badge bg-white text-info">{{ filteredStatement.length }} entries</span>
                  </div>
                  <div class="card-body p-0">
                    <div class="table-responsive">
                      <table class="table table-hover table-striped table-bordered mb-0">
                        <thead class="table-light">
                        <tr>
                          <th style="width: 50px">#</th>
                          <th style="width: 120px">Date</th>
                          <th style="width: 120px">Type</th>
                          <th>Description</th>
                          <th class="text-end" style="width: 130px">Debit (KES)</th>
                          <th class="text-end" style="width: 130px">Credit (KES)</th>
                          <th class="text-end" style="width: 140px">Balance (KES)</th>
                        </tr>
                        </thead>
                        <tbody>
                        <!-- Transaction Rows -->
                        <tr v-for="(entry, index) in filteredStatement" :key="index"
                            :class="{'table-secondary': entry.type === 'Arrears'}">
                          <td>{{ index + 1 }}</td>
                          <td>{{ formatDate(entry.date) }}</td>
                          <td>
                            <span class="badge" :class="getTypeBadgeClass(entry.type)">
                              {{ entry.type }}
                            </span>
                          </td>
                          <td>{{ formatDescription(entry) }}</td>
                          <td class="text-end">
                            <span v-if="entry.debit > 0" class="text-danger">
                              {{ numberFormat(entry.debit) }}
                            </span>
                            <span v-else>-</span>
                          </td>
                          <td class="text-end">
                            <span v-if="entry.credit > 0" class="text-success">
                              {{ numberFormat(entry.credit) }}
                            </span>
                            <span v-else>-</span>
                          </td>
                          <td class="text-end">
                            <strong :class="entry.balance > 0 ? 'text-danger' : 'text-success'">
                              {{ numberFormat(entry.balance) }}
                            </strong>
                          </td>
                        </tr>

                        <!-- Empty State -->
                        <tr v-if="filteredStatement.length === 0">
                          <td colspan="7" class="text-center py-5">
                            <i class="mdi mdi-file-document-outline display-4 text-muted"></i>
                            <p class="text-muted mt-2 mb-0">No transactions found</p>
                          </td>
                        </tr>

                        <!-- Closing Balance Row -->
                        <tr class="table-dark" v-if="filteredStatement.length > 0">
                          <td colspan="4"><strong class="text-white">Closing Balance</strong></td>
                          <td class="text-end text-white"><strong>{{ numberFormat(summary.totalDebits) }}</strong></td>
                          <td class="text-end text-white"><strong>{{ numberFormat(summary.totalCredits) }}</strong></td>
                          <td class="text-end"><strong class="text-warning">KES {{ numberFormat(summary.currentBalance) }}</strong></td>
                        </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Summary Cards Row -->
            <div class="row">
              <div class="col-md-6">
                <div class="card">
                  <div class="card-header bg-success">
                    <h5 class="card-title mb-0 text-white">
                      <i class="mdi mdi-chart-box-outline me-2"></i>Statement Summary
                    </h5>
                  </div>
                  <div class="card-body">
                    <table class="table table-borderless mb-0">
                      <tbody>
                      <tr>
                        <td class="text-muted">Total Debits (Charges):</td>
                        <td class="text-end text-danger"><strong>+ KES {{ numberFormat(summary.totalDebits) }}</strong></td>
                      </tr>
                      <tr>
                        <td class="text-muted">Total Credits (Payments):</td>
                        <td class="text-end text-success"><strong>- KES {{ numberFormat(summary.totalCredits) }}</strong></td>
                      </tr>
                      <tr class="border-top">
                        <td class="fw-bold">Current Balance:</td>
                        <td class="text-end">
                          <strong class="font-size-18" :class="summary.currentBalance > 0 ? 'text-danger' : 'text-success'">
                            KES {{ numberFormat(summary.currentBalance) }}
                          </strong>
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>

              <div class="col-md-6">
                <div class="card">
                  <div class="card-header bg-warning">
                    <h5 class="card-title mb-0 text-white">
                      <i class="mdi mdi-counter me-2"></i>Transaction Counts
                    </h5>
                  </div>
                  <div class="card-body">
                    <div class="row text-center">
                      <div class="col-6 mb-3">
                        <div class="p-3 bg-light rounded">
                          <i class="mdi mdi-file-document-multiple-outline text-primary font-size-24"></i>
                          <h4 class="mb-0 mt-2">{{ statement.length }}</h4>
                          <small class="text-muted">Total Entries</small>
                        </div>
                      </div>
                      <div class="col-6 mb-3">
                        <div class="p-3 bg-light rounded">
                          <i class="mdi mdi-cash-check text-success font-size-24"></i>
                          <h4 class="mb-0 mt-2">{{ paymentCount }}</h4>
                          <small class="text-muted">Payments Made</small>
                        </div>
                      </div>
                      <div class="col-6">
                        <div class="p-3 bg-light rounded">
                          <i class="mdi mdi-calendar-check text-info font-size-24"></i>
                          <h4 class="mb-0 mt-2">{{ annualRentCount }}</h4>
                          <small class="text-muted">Annual Rent Charges</small>
                        </div>
                      </div>
                      <div class="col-6">
                        <div class="p-3 bg-light rounded">
                          <i class="mdi mdi-percent text-danger font-size-24"></i>
                          <h4 class="mb-0 mt-2">{{ penaltyCount }}</h4>
                          <small class="text-muted">Penalties Applied</small>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Annual Charges Card -->
            <div class="row">
              <div class="col-12">
                <div class="card">
                  <div class="card-header bg-primary">
                    <h5 class="card-title mb-0 text-white">
                      <i class="mdi mdi-calendar-clock me-2"></i>Annual Rent Information
                    </h5>
                  </div>
                  <div class="card-body">
                    <div class="row text-center">
                      <div class="col-md-4">
                        <div class="p-3 border rounded">
                          <small class="text-muted d-block">Annual Rent</small>
                          <h4 class="mb-0 text-primary">KES {{ numberFormat(plot.annualRent) }}</h4>
                        </div>
                      </div>
                      <div class="col-md-4">
                        <div class="p-3 border rounded">
                          <small class="text-muted d-block">Last Billing Year</small>
                          <h4 class="mb-0 text-info">{{ plot.lastBillingYear || '-' }}</h4>
                        </div>
                      </div>
                      <div class="col-md-4">
                        <div class="p-3 border rounded bg-light">
                          <small class="text-muted d-block">Current Balance</small>
                          <h4 class="mb-0" :class="parseFloat(plot.currentBalance) > 0 ? 'text-danger' : 'text-success'">
                            KES {{ numberFormat(plot.currentBalance) }}
                          </h4>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Footer Note -->
            <div class="row">
              <div class="col-12">
                <div class="text-center text-muted mb-4">
                  <small>
                    <i class="mdi mdi-information-outline me-1"></i>
                    Statement generated on {{ formatDateTime(new Date()) }} |
                    For inquiries, please contact the Revenue Office
                  </small>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>

  </div>
  </body>
</template>

<script>
import NavigationBar from "@/components/Navigation.vue";
import {execute, plotRent} from "@/api";

export default {
  name: 'PlotStatements',
  components: {
    NavigationBar
  },
  data() {
    return {
      loading: false,
      error: null,
      message: null,
      plot: null,
      statement: [],
      summary: {
        totalDebits: 0,
        totalCredits: 0,
        currentBalance: 0
      },
      filters: {
        transactionType: ''
      },
      plotID: '',
      plotNumber: '',
      plotZone: ''
    }
  },
  computed: {
    filteredStatement() {
      let filtered = [...this.statement];

      if (this.filters.transactionType) {
        filtered = filtered.filter(entry => entry.type === this.filters.transactionType);
      }

      return filtered;
    },

    paymentCount() {
      return this.statement.filter(entry => entry.type === 'Payment').length;
    },

    penaltyCount() {
      return this.statement.filter(entry => entry.type === 'Penalty').length;
    },

    annualRentCount() {
      return this.statement.filter(entry => entry.type === 'Annual Rent').length;
    }
  },
  mounted() {
    this.plotID = sessionStorage.getItem("plotID") || '';
    this.plotNumber = sessionStorage.getItem("plotNumber") || '';
    this.plotZone = sessionStorage.getItem("plotZone") || '';

    if (!this.plotID) {
      this.error = "No plot selected. Please go back and select a plot.";
      return;
    }

    this.fetchStatement();
  },
  methods: {

    fetchStatement() {
      this.loading = true;
      this.error = null;

      const data = new FormData();
      data.append("function", "getAccountStatement");
      data.append("plotID", this.plotID);

      execute(data, plotRent)
          .then((res) => {
            this.loading = false;
            if (res.data.success) {
              this.plot = res.data.data.plot;
              this.statement = res.data.data.statement || [];
              this.summary = res.data.data.summary || {
                totalDebits: 0,
                totalCredits: 0,
                currentBalance: 0
              };
            } else {
              this.error = res.data.message;
              this.message = res.data.message;
            }
          })
          .catch((e) => {
            this.loading = false;
            this.error = e.message;
            this.message = e.message;
          });
    },

    formatDescription(entry) {
      if (entry.type === 'Payment') {
        return 'Payment Received';
      }
      return entry.description;
    },

    applyFilter() {
      // Filter is applied reactively via computed property
    },

    clearFilters() {
      this.filters = {
        transactionType: ''
      };
    },

    getTypeBadgeClass(type) {
      switch (type) {
        case 'Payment':
          return 'bg-success';
        case 'Penalty':
          return 'bg-danger';
        case 'Annual Rent':
          return 'bg-info';
        case 'Arrears':
          return 'bg-secondary';
        default:
          return 'bg-primary';
      }
    },

    exportToCSV() {
      if (this.filteredStatement.length === 0) {
        alert('No data to export');
        return;
      }

      let csvContent = '';

      csvContent += 'PLOT RENT STATEMENT\n';
      csvContent += '\n';
      csvContent += 'Plot Details\n';
      csvContent += `Plot Number,${this.escapeCSV(this.plot.plotNumber)}\n`;
      csvContent += `Zone,${this.escapeCSV(this.plot.zone)}\n`;
      csvContent += `Owner Name,${this.escapeCSV(this.plot.ownerNames)}\n`;
      csvContent += `Sub County,${this.escapeCSV(this.plot.subCountyName)}\n`;
      csvContent += `Ward,${this.escapeCSV(this.plot.wardName)}\n`;
      csvContent += `Phone,${this.escapeCSV(this.plot.ownerPhoneNo)}\n`;
      csvContent += '\n';

      csvContent += 'Account Summary\n';
      csvContent += `Arrears B/F,${this.plot.arrearsForward || 0}\n`;
      csvContent += `Total Billed,${this.plot.totalBilled || 0}\n`;
      csvContent += `Accumulated Penalty,${this.plot.accumulatedPenalty || 0}\n`;
      csvContent += `Total Payments,${this.plot.totalPayments || 0}\n`;
      csvContent += `Annual Rent,${this.plot.annualRent || 0}\n`;
      csvContent += `Current Balance,${this.plot.currentBalance || 0}\n`;
      csvContent += '\n';

      csvContent += 'Statement Transactions\n';
      csvContent += '#,Date,Type,Description,Debit (KES),Credit (KES),Balance (KES)\n';

      this.filteredStatement.forEach((entry, index) => {
        const row = [
          index + 1,
          this.formatDateForCSV(entry.date),
          this.escapeCSV(entry.type),
          this.escapeCSV(this.formatDescription(entry)),
          entry.debit > 0 ? entry.debit : '',
          entry.credit > 0 ? entry.credit : '',
          entry.balance
        ];
        csvContent += row.join(',') + '\n';
      });

      csvContent += '\n';
      csvContent += `,,,,${this.summary.totalDebits},${this.summary.totalCredits},${this.summary.currentBalance}\n`;
      csvContent += ',,,Total Debits,Total Credits,Closing Balance\n';

      const dateStr = new Date().toISOString().slice(0, 10);
      const plotNum = (this.plot.plotNumber || 'plot').replace(/[^a-zA-Z0-9]/g, '_');
      const filename = `Plot_Statement_${plotNum}_${dateStr}.csv`;

      this.downloadCSV(csvContent, filename);
    },

    escapeCSV(value) {
      if (value === null || value === undefined) return '';
      const str = String(value);
      if (str.includes(',') || str.includes('"') || str.includes('\n')) {
        return '"' + str.replace(/"/g, '""') + '"';
      }
      return str;
    },

    formatDateForCSV(date) {
      if (!date) return '';
      const d = new Date(date);
      const day = String(d.getDate()).padStart(2, '0');
      const month = String(d.getMonth() + 1).padStart(2, '0');
      const year = d.getFullYear();
      return `${day}/${month}/${year}`;
    },

    downloadCSV(content, filename) {
      const blob = new Blob([content], { type: 'text/csv;charset=utf-8;' });
      const link = document.createElement('a');

      if (navigator.msSaveBlob) {
        navigator.msSaveBlob(blob, filename);
      } else {
        link.href = URL.createObjectURL(blob);
        link.download = filename;
        link.style.visibility = 'hidden';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    },

    goBack() {
      this.$router.push('/plot-rent');
    },

    formatDate(date) {
      if (!date) return '-';
      const d = new Date(date);
      return d.toLocaleDateString('en-GB', {
        day: '2-digit',
        month: 'short',
        year: 'numeric'
      });
    },

    formatDateTime(date) {
      if (!date) return '-';
      const d = new Date(date);
      return d.toLocaleString('en-GB', {
        day: '2-digit',
        month: 'short',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      });
    },

    numberFormat(num) {
      const value = parseFloat(num) || 0;
      return new Intl.NumberFormat('en-GB', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(value);
    }
  }
}
</script>

<style scoped>
.table th {
  font-weight: 600;
  text-transform: uppercase;
  font-size: 0.75rem;
  letter-spacing: 0.5px;
}

.table td {
  vertical-align: middle;
}

.badge {
  font-weight: 500;
  padding: 5px 10px;
}

.font-size-16 {
  font-size: 16px;
}

.font-size-18 {
  font-size: 18px;
}

.font-size-24 {
  font-size: 24px;
}

@media (max-width: 768px) {
  .table-responsive {
    font-size: 0.85rem;
  }
}
</style>